import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ChargeSummary as ApiChargeSummary } from 'models/TransactionEstimates'

/**
 * StoreChargeSummary is the Redux store version of the ChargeSummary type
 * with camelCase property names instead of snake_case from the API
 */
export interface ChargeSummary {
  feeOnTop: boolean
  feeOnTopAmount: number
  totalCharge: number
}

/**
 * ChargeSummary contains information about the total charge amount,
 * including whether fees are covered by the donor (fee_on_top)
 * and the additional fee amount if applicable.
 */
const initialState: ChargeSummary = {
  feeOnTop: false,
  feeOnTopAmount: 0,
  totalCharge: 0,
}

// NOTE: Currently not used, but keeping for future reference.
// Uncomment the code in CheckoutSummary if we decide to use this in the future.
export const chargeSummarySlice = createSlice({
  name: 'chargeSummary',
  initialState,
  reducers: {
    // Reducer to set the entire charge summary at once
    setChargeSummary: (_state, action: PayloadAction<ChargeSummary>) => {
      return action.payload
    },
    clearChargeSummary: () => {
      return initialState
    },
  },
})

/**
 * Utility function to convert API ChargeSummary to store format
 */
export const apiToStoreChargeSummary = (apiChargeSummary: ApiChargeSummary): ChargeSummary => {
  return {
    feeOnTop: apiChargeSummary.fee_on_top,
    feeOnTopAmount: Number(apiChargeSummary.fee_on_top_amount),
    totalCharge: Number(apiChargeSummary.total_charge),
  }
}

export const { setChargeSummary, clearChargeSummary } = chargeSummarySlice.actions

export default chargeSummarySlice.reducer
